import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import PropTypes from 'prop-types';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import StandardLayout from '../../templates/StandardLayout';

const ImpressumComponent = ({ heading, textSections }) => (
  <StandardLayout>
    <div className="impressum-page">
      <h1>{heading}</h1>
      <div className="grid-container">
        <div className="grid-x grid-margin-x">
          <div className="cell">
            <Paragraph alignment="center">
              {R.prop('impressumText', textSections)}
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

ImpressumComponent.propTypes = {
  textSections: PropTypes.arrayOf(PropTypes.object),
  heading: PropTypes.string,
};

export default connect(({ content }) => ({
  textSections: R.prop('textSections', content),
  heading: R.prop('heading', content),
}))(ImpressumComponent);
